var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-tooltip', { attrs: { "effect": "dark", "popper-class": "res-custom-tooltip", "content": _vm.$t('playTurbo.creative.categoryConfig.reset'), "placement": "top" } }, [_vm.originalJson && _vm.currentOriginalConfig ? _c('el-button', _vm._b({ on: { "click": _vm.handleClick } }, 'el-button', _vm.buttonAttrs, false), [_c('svg-icon', { attrs: { "icon-class": "reset", "size": 22 } })], 1) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };